import { CreateMessageDialog } from './CreateMessageDialog';
import { useOpenClose } from 'core/hooks/useOpenClose';

/** メッセージ機能のコンポーネント。 */
export const Messages = () => {
  const { isOpen, handleOpen, handleClose } = useOpenClose();

  return (
    <>
      <button
        className="text-[18px] text-textPrimary noto-sans-jp-bold"
        onClick={handleOpen}
      >
        メッセージ
      </button>
      <CreateMessageDialog open={isOpen} onClose={handleClose} />
    </>
  );
}; 